import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Menu: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <path d="M13.082 10.15c.507 0 .918.425.918.949s-.41.949-.918.949c-.035 0-.068-.007-.102-.011L.905 12.05v-.004C.405 12.04 0 11.618 0 11.1c0-.524.41-.949.918-.949l.027.003h12.11l.027-.003zm0-4.1c.507 0 .918.425.918.949s-.41.949-.918.949c-.035 0-.068-.007-.102-.011L.905 7.95v-.004C.405 7.94 0 7.518 0 7c0-.524.41-.949.918-.949l.027.003h12.11l.027-.003zm0-4.1c.507 0 .918.425.918.949s-.41.949-.918.949c-.035 0-.068-.007-.102-.011L.905 3.85v-.004C.405 3.84 0 3.418 0 2.9c0-.524.41-.949.918-.949l.027.003h12.11l.027-.003z" />
  </Icon>
);
